import { PhoneType } from '@grc/ui-shared/lib/components/models/enums/enums';
import { initialTemperatureControl } from '@grc/ui-shared/lib/components/common/constants/constants';
import {
  HazardClass,
  IHandlingUnit,
  IPackingGroup
} from '../models/create-quote/handling-unit.interface';
import { IProduct } from '../models/create-quote/product.interface';
import { IQuoteModel } from '../models/create-quote/quote.interface';
import { v4 as uuidv4 } from 'uuid';
import { ServiceLevel } from '../enums/quote.enum';

export const initialHandlingUnitState: IHandlingUnit = {
  handlingUnitId: uuidv4(),
  handlingUnitTypeId: '',
  handlingUnitType: '',
  quantity: 0,
  dimensions: {
    shape: 1,
    length: null,
    width: null,
    height: null,
    diameter: null
  },
  weight: {
    Unit: 'MassUnit.Pound',
    Value: 0
  },
  nmfc: '',
  nmfcClassName: '',
  nmfcClassId: '',
  productDescription: '',
  hasHazmat: false,
  isNonStackable: false,
  hasTemperatureControl: false,
  temperatureControl: initialTemperatureControl
};

export const initialProduct: IProduct = {
  id: uuidv4(),
  productId: '',
  productName: '',
  dimensions: {
    shape: 1,
    length: null,
    width: null,
    height: null,
    diameter: null
  },
  quantity: 0,
  weight: {
    Unit: 'MassUnit.Pound',
    Value: 0
  },
  productDescription: ''
};

export const initialQuoteState: IQuoteModel = {
  account: {
    id: '',
    name: ''
  },
  requestedBy: '',
  handlingUnits: [initialHandlingUnitState],
  products: [initialProduct],
  closeDeliveryDate: undefined,
  closePickupDate: undefined,
  readyDeliveryDate: undefined,
  readyPickupDate: undefined,
  shipper: undefined,
  consignee: undefined,
  shipperDefaultContactDetails: undefined,
  consigneeDefaultContactDetails: undefined,
  originContacts: [],
  destinationContacts: [],
  shipperCareOfDetails: {
    id: '',
    firstName: '',
    lastName: '',
    contactType: 'Mobile',
    mobile: '',
    position: '',
    email: '',
    phoneNumber: {
      phoneType: PhoneType.Mobile,
      phoneNumber: '',
      displayOrder: 1
    }
  },
  consigneeCareOfDetails: {
    id: '',
    firstName: '',
    lastName: '',
    contactType: 'Mobile',
    mobile: '',
    position: '',
    email: '',
    phoneNumber: {
      phoneType: PhoneType.Mobile,
      phoneNumber: '',
      displayOrder: 1
    }
  },
  serviceLevel: ServiceLevel.Standard,
  serviceLevelType: '',
  isEmailUpdateChecked: false,
  emailDetails: [{ displayOrder: 1, email: '' }],
  isMobileUpdateChecked: false,
  phoneDetails: [
    {
      phoneType: PhoneType.Mobile,
      phoneNumber: '+1 ',
      displayOrder: 1
    }
  ],
  specialInstructions: '',
  selectedTab: 0,
  isEnableLocationCreationMode: false,
  creatingEntity: '',
  isAccessorialNotRequired: true,
  searchedAccessorial: ''
};

export const hazardClasses = [
  {
    id: HazardClass.Class1,
    value: 1
  },
  {
    id: HazardClass.Class2,
    value: 2
  },
  {
    id: HazardClass.Class3,
    value: 3
  },
  {
    id: HazardClass.Class4,
    value: 4
  },
  {
    id: HazardClass.Class5,
    value: 5
  },
  {
    id: HazardClass.Class6,
    value: 6
  },
  {
    id: HazardClass.Class7,
    value: 7
  },
  {
    id: HazardClass.Class8,
    value: 8
  },
  {
    id: HazardClass.Class9,
    value: 9
  }
];

export const packagingGroupList = [
  {
    id: IPackingGroup.Single,
    text: 'Single'
  },
  {
    id: IPackingGroup.Composite,
    text: 'Composite'
  },
  {
    id: IPackingGroup.Combination,
    text: 'Combination'
  }
];

export const telephoneType = ['Mobile', 'Home', 'Work', 'Fax', 'Other'];

export const serviceOptions = [
  { id: ServiceLevel.Standard, name: 'Standard' },
  { id: ServiceLevel.Expedited, name: 'Expedite' }
];
